import { collectionEngineV1 } from '../apis.js';
import { APIBASE } from '../config.js';
import { authToken } from '../internal.js';
import { getTenantId } from '../tenant/selected.js';
const cosmoV2API = collectionEngineV1('/cosmoV2');
export const getProviderSubscriptions = (userId) => cosmoV2API('GET', `/provider-subscriptions/${userId}`);
export const lookupUser = (body) => cosmoV2API('POST', `/lookup`, { body });
export const subscribeUser = (userId) => cosmoV2API('POST', `/subscribe/${userId}`);
export const unsubscribeUser = (userId) => cosmoV2API('POST', `/unsubscribe/${userId}`);
export const getSettings = () => cosmoV2API('GET', '/settings');
export const updateSettings = (settings) => cosmoV2API('PATCH', '/settings', {
    body: settings,
});
export const getDebugInfo = (userId) => cosmoV2API('GET', `/debug-user/${userId}`);
export const doUserDebugAction = (userId, action) => cosmoV2API('POST', `/debug-user/${userId}/${action}`);
export const getDebugBronzeEvent = (eventId) => cosmoV2API('GET', `/debug/bronze-event/${eventId}`);
export const doTenantDebugAction = (action, body) => cosmoV2API('POST', `/debug-tenant/${action}`, {
    body,
});
export const pushMockedBronzeEvent = (userId, provider, data, subscriptionId) => cosmoV2API('POST', `/debug/mock-event/${userId}`, {
    body: {
        provider,
        data,
        subscriptionId,
    },
});
export const getDoctorStream = () => {
    const tenantId = getTenantId();
    return fetch(`${APIBASE}/collection-engine/v1/${tenantId}/cosmoV2/doctor`, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
            'X-Debbie-Auth-Token': authToken,
        },
    }).then((x) => {
        if (x.status >= 400) {
            throw new Error('Error fetching doctor stream');
        }
        return x.body;
    });
};
export const doctorFix = (check) => cosmoV2API('POST', `/doctor/fix/${check}`);
export const searchEntities = (body) => cosmoV2API('POST', `/search`, { body });
export const refetchSubscription = (subscriptionId) => cosmoV2API('POST', `/refetch-subscription/${subscriptionId}`);
export const refetchAllSubscriptions = (provider) => cosmoV2API('POST', `/refetch-all-subscriptions/${provider}`);
export const getUserAssets = (userId) => cosmoV2API('GET', `/assets/${userId}`);
export const createUserAsset = (userId, body) => cosmoV2API('POST', `/assets/${userId}`, { body });
export const updateUserAsset = (userId, assetId, body) => cosmoV2API('PATCH', `/assets/${userId}/${assetId}`, { body });
export const deleteUserAsset = (userId, assetId) => cosmoV2API('DELETE', `/assets/${userId}/${assetId}`);
export const addAssetLien = (userId, assetId, body) => cosmoV2API('POST', `/assets/${userId}/${assetId}/liens`, { body });
export const deleteAssetLien = (userId, assetId, lienId) => cosmoV2API('DELETE', `/assets/${userId}/${assetId}/liens/${lienId}`);
export const updateAssetLien = (userId, assetId, lienId, body) => cosmoV2API('PATCH', `/assets/${userId}/${assetId}/liens/${lienId}`, {
    body,
});
export const createUserNote = (userId, body) => cosmoV2API('POST', `/users/${userId}/notes`, { body });
export const patchUserNote = (userId, noteId, body) => cosmoV2API('PATCH', `/users/${userId}/notes/${noteId}`, { body });
export const deleteUserNote = (userId, noteId) => cosmoV2API('DELETE', `/users/${userId}/notes/${noteId}`);
//# sourceMappingURL=cosmoV2.js.map